import { RequestFactory } from "@/requests/RequestFactory";
const organizacaoRequest = RequestFactory.get("organizacao");

export default {
  namespaced: true,
  state: {
    isFetching: false,
    items: {},
  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchAllOrganizacoes: ({ dispatch }) => dispatch('fetchAllItems', { resource: 'organizacao' }, { root: true }),

    criarOrganizacao({ commit, dispatch }, organizacao) {
      dispatch('requestOn');
      return organizacaoRequest.post(organizacao).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'organizacao', item: response.data }
        
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Organização criada com sucesso'
        }

        dispatch('notification/add', notification, { root: true })


        return response.data
      })
    },

    editarOrganizacao({ commit, dispatch }, organizacao) {
      dispatch('requestOn');
      return organizacaoRequest.put(organizacao.id, organizacao).then(response => {
        dispatch('requestOff');
        const payload = { resource: 'organizacao', item: response.data }
        commit('setItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Organização editada com sucesso'
        }

        dispatch('notification/add', notification, { root: true })


        return response.data
      })
    },

    deletarOrganizacao({ commit, dispatch }, organizacaoId) {
      dispatch('requestOn');
      return organizacaoRequest.delete(organizacaoId).then(() => {
        dispatch('requestOff');
        const payload = { resource: 'organizacao', itemId: organizacaoId }
        commit('deleteItem', payload, { root: true })

        const notification = {
          type: 'success',
          message: 'Organização removida com sucesso'
        }

        return dispatch('notification/add', notification, { root: true })
      })
    },

  },

  getters: {
    all: state => {
      return state.items ? Object.values(state.items) : []
    },
  },

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }    
  }
}
